import React, { Component } from "react";

export default class HTML extends Component {

    render() {

        return(<div>Placeholder.</div>);

    }
    
}